require('./openYoungCardAcceptSavingsView.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

//@ Commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardChargeActions = require('actions/cardCharge');
const openYoungCardSavings = require('actions/openYoungCardSavings');
const juniorAccountActions = require('actions/hireJuniorAccount');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardCharge = require('components/cards/cardCharge/cardCharge');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardChargeSuccessStep = require('components/cards/cardChargeSteps/cardChargeSuccessStep/cardChargeSuccessStep');
const CardChargeErrorStep = require('components/cards/cardChargeSteps/cardChargeErrorStep/cardChargeErrorStep');
const CardChargeNoOpenYoungAccount = require('components/cards/cardChargeSteps/cardChargeNoOpenYoungAccount/cardChargeNoOpenYoungAccount');
const CardChargeNoBalanceStep = require('components/cards/cardChargeSteps/cardChargeNoBalanceStep/cardChargeNoBalanceStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');

// @constants
const {
    GRAPHIC_TUTOR_TYPE_4,
    SAVINGS_REQUEST_VIEW,
    ACCEPT_MONEY_REQUEST_STATUS,
    CARD_CHARGE_OPERATION_DISCHARGE
} = require('constants/index');

class OpenYoungCardAcceptSavingsView extends React.Component {
    constructor(props) {
        super(props);
        this.postChange = this.postChange.bind(this);
    }

    componentDidMount() {
        const {
            match: { params: { cardId } },
            getOYAccountsList,
            requestECardInfo,
            history,
            immCards,
            immAccounts,
            openYoungCardSavings,
            setAccount,
            setAmount,
            setOperationType,
            setView
        } = this.props;
        const amountRequested = openYoungCardSavings.getIn(['savingsDetail', 'requestAmount']);
        const immCard = immCards.getIn(['byId', cardId]);
        getOYAccountsList(immCard);
        AccessHelper.allowAccess(cardConstants.CARD_CHARGE, { immCard }, history);
        requestECardInfo(cardId);
        setAccount(immAccounts.getIn(['byOrder', 0]));
        setAmount(amountRequested);
        setOperationType(CARD_CHARGE_OPERATION_DISCHARGE);
        setView(SAVINGS_REQUEST_VIEW);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    postChange() {
        const { match: { params: { cardId } }, postChange } = this.props;
        postChange(cardId, ACCEPT_MONEY_REQUEST_STATUS);
    }

    render() {
        const {
            match: { params: { cardId } },
            immCards,
            immCardCharge,
            validateStep,
            setVisibleStep,
            setWillCancel,
            setAccount,
            setJuniorAccountHiringInitiationPoint,
            immAccounts,
            requestECardInfo,
            openYoungCardSavings
        } = this.props;
        let openYoungAccounts;
        const immCard = immCards.getIn(['byId', cardId]);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('moneySavingsRequest-acceptTitle')}
            />
        );
        const mappingBreadcrumb = [
            {
                text: formatText('moneySavingsRequest-acceptBreadcrumbText'),
                url: ''
            }
        ];

        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.getIn(['alias', 'current']);
        const savingsDetails = openYoungCardSavings.get('savingsDetail');
        const isFetching = openYoungCardSavings.get('isFetchingOYAccounts');
        if (!isFetching) {
            openYoungAccounts = openYoungCardSavings.get('oyAccounts');
            if (openYoungAccounts.size !== 0) {
                setAccount(openYoungAccounts.get(0));
            }
        }
        const realAmount = immCard.getIn(['extra', 'eCardInfo', 'saldoActualPrepago', 'importe']);
        const noBalaceInChildsAccount = (realAmount === 0);
        let bodyContent;

        if (isFetching) {
            bodyContent = <LoadingSection />
        } else if (openYoungAccounts.size === 0) {
            bodyContent = (
                <CardChargeNoOpenYoungAccount
                    immCard={immCard}
                    amount={openYoungCardSavings.getIn(['savingsDetail', 'requestAmount'])}
                    setJuniorAccountHiringInitiationPoint={setJuniorAccountHiringInitiationPoint}
                />
            );
        } else if (noBalaceInChildsAccount) {
            bodyContent = (
                <CardChargeNoBalanceStep
                    immCard={immCard}
                />
            );
        } else if (immCardCharge.get('submitSuccessful')) {
            bodyContent = (
                <CardChargeSuccessStep
                    immAccounts={immAccounts}
                    immCard={immCard}
                    immCardCharge={immCardCharge}
                    loading={immCardCharge.get('isFetching')}
                    requestEcardInfo={requestECardInfo}
                    view={SAVINGS_REQUEST_VIEW}
                />
            );
        } else if (immCardCharge.get('blockFlow')) {
            const messageObject = {
                title: 'moneySavingsRequest-errorTitle',
                message: 'moneySavingsRequest-errorMessage',
                goBackLink: 'myprofile/global'
            };
            bodyContent = <CardChargeErrorStep immCard={immCard} messageObject={messageObject} />;
        } else {
            bodyContent = (
                <div>
                    <div className="col-xs-12 col-md-8">
                        <CardCharge
                            immAccounts={immAccounts}
                            immCard={immCard}
                            immCardCharge={immCardCharge}
                            validateStep={validateStep}
                            setVisibleStep={setVisibleStep}
                            setWillCancel={setWillCancel}
                            postChange={this.postChange}
                            view={SAVINGS_REQUEST_VIEW}
                            moneyRequestDetails={savingsDetails}
                            oyAccounts={openYoungAccounts}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                        <CardDetailsSidebar immCard={immCard} />
                    </div>
                </div>
            );
        }

        return (
            <div className="openyoung-card-accept-savings-view">
                <div className="container-fluid card-charge-view--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('moneySavingsRequest-acceptTitle')}
                            >
                                <CardHeaderDetails
                                    immCard={immCard}
                                    isFetching={immCardCharge.get('isFetching')}
                                />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungCardAcceptSavingsView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    getOYAccountsList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    openYoungCardSavings: PropTypes.object.isRequired,
    postChange: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestECardInfo: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setAmount: PropTypes.func,
    setAccount: PropTypes.func.isRequired,
    setOperationType: PropTypes.func.isRequired,
    setView: PropTypes.func.isRequired,
    setJuniorAccountHiringInitiationPoint: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
}

module.exports.Constructor = OpenYoungCardAcceptSavingsView;
module.exports.OpenYoungCardAcceptSavingsView = connect(
    state => ({
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immAccounts: state.accounts,
        openYoungCardSavings: state.openYoungCardSavings
    }),
    {
        clearRequest: cardChargeActions.clearRequest,
        getOYAccountsList: openYoungCardSavings.getOYAccountsList,
        postChange: openYoungCardSavings.postChange,
        requestECardInfo: cardChargeActions.requestECardInfo,
        setVisibleStep: cardChargeActions.setVisibleStep,
        setWillCancel: cardChargeActions.setWillCancel,
        setAccount: cardChargeActions.setAccount,
        setAmount: cardChargeActions.setAmount,
        setOperationType: cardChargeActions.setOperationType,
        setView: cardChargeActions.setView,
        setJuniorAccountHiringInitiationPoint: juniorAccountActions.setJuniorAccountHiringInitiationPoint,
        validateStep: cardChargeActions.validateStep

    })(withRouter(OpenYoungCardAcceptSavingsView));
